
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { ExamV2Custom, Mind } from "@/lib/model/exambuilder/exam-v2";
import draggable from "vuedraggable";
import Pop from "../components/blue-pop.vue";
import Loading from "../../../components/loading.vue";

@Component({
  components: {
    draggable,
    Loading,
    Pop
  }
})
export default class SetQuestion extends Vue {
  @Prop({ type: ExamV2Custom, default: new ExamV2Custom() })
  exam!: ExamV2Custom; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop({}) companyPower!: any; //公司权限

  showDetail = false;
  gameDetail = false;
  detailModel: any = {};
  // 数据加载完成前不展示空页面
  dataLoaded = false;
  now = 1; //类别
  showFIVE = false;
  mindList: any[] = [];
  fiveOptionEditingList: any = {}; //正在选择中的维度

  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答

  @Watch("exam")
  initData() {
    //
  }
  //大五人格 所有子维度
  get fiveMindSonList() {
    const list: any[] = [];
    this.mindList?.[0]?.dimensionList.forEach((d: any) => {
      d?.subDimensionList.forEach((m: any) => {
        list.push(m);
      });
    });
    return list;
  }
  //大五人格 已选子维度 name 题数
  get fiveSelectSon() {
    const res = { name: "", questionNum: 0 };
    this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList.forEach(
      (d: number) => {
        this.fiveMindSonList.forEach((m: any) => {
          if (d === m.psycGaugeDimensionId) {
            res.name += m.psycGaugeDimensionName + "、";
            res.questionNum += Number(m.questionCount);
          }
        });
      }
    );
    res.name = res.name.slice(0, res.name.length - 1);
    console.log(res);
    return res;
  }
  //已选的心理量表 全部信息
  get mindTypeNow() {
    return (
      this.mindList.find(
        d => d.psycGaugeId === this.exam.psycGaugeConfig.psycGaugeId
      ) || {}
    );
  }
  get notAllow() {
    return this.isCandidateUsed || this?.companyPower?.enablePsycTest !== 1;
  }
  get notAllowGame() {
    return this.isCandidateUsed || this?.companyPower?.enableGameTest !== 1;
  }

  async mounted() {
    await this.selectType(1);
    this.dataLoaded = true;
  }
  //选择类别
  async selectType(i: number) {
    this.now = i;
    if (i === 1) {
      await this.getMindList();
    }
  }
  //获取所有心理量表
  async getMindList() {
    await Mind.get().then(res => {
      if (res.data.code === 0) {
        this.mindList = res.data.data.list;
      }
    });
  }
  //大五人格 已选中子维度class
  setChked(id: number) {
    return this.fiveOptionEditingList?.psycGaugeSubDimensionIdList?.find(
      (res: number) => res === id
    );
  }
  //大五人格 选
  selectFiveSon(id: number) {
    const i = this.fiveOptionEditingList.psycGaugeSubDimensionIdList?.findIndex(
      (res: number) => res === id
    );
    if (i === -1) {
      this.fiveOptionEditingList.psycGaugeSubDimensionIdList.push(id);
    } else {
      this.fiveOptionEditingList.psycGaugeSubDimensionIdList.splice(i, 1);
    }
  }
  //大五 打开  记下当前
  openFIVE() {
    if (this.notAllow) return false;
    this.fiveOptionEditingList = JSON.parse(
      JSON.stringify(this.exam.psycGaugeConfig)
    );
    this.showFIVE = true;
  }
  //大五弹窗 取消
  cancelFIVE() {
    this.showFIVE = false;
  }
  //大五弹窗 确认
  okFIVE() {
    if (this.notAllow) return false;
    //0滤掉
    this.fiveOptionEditingList.psycGaugeSubDimensionIdList = this.fiveOptionEditingList.psycGaugeSubDimensionIdList.filter(
      (d: number) => {
        return d !== 0;
      }
    );
    if (this.fiveOptionEditingList.psycGaugeSubDimensionIdList.length > 0) {
      this.exam.psycGaugeConfig = JSON.parse(
        JSON.stringify(this.fiveOptionEditingList)
      );
      this.exam.psycGaugeConfig.psycGaugeId = 1;
      this.$forceUpdate();

      this.showFIVE = false;
      this.change();
    } else {
      this.$message.warning("至少选择一个维度");
    }
  }
  sn() {
    if (this.notAllow) return false;
    this.exam.psycGaugeConfig.psycGaugeId = 0;
    this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList = [];
  }
  openDetail(i: number) {
    this.detailModel = this.mindList[i];
    this.$nextTick().then(() => {
      this.showDetail = true;
    });
  }
  okDetail() {
    this.openFIVE();
    this.showDetail = false;
  }

  checkData() {
    let res = true;
    if (
      this.exam.psycGaugeConfig.psycGaugeId === 1 &&
      this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList.length < 1
    ) {
      res = false;
      this.$message.warning("若使用心理测评·OCEAN人格评估，请至少选择一个维度");
    }
    return res;
  }
  setGame(index = 0) {
    if (this.notAllowGame) return false;
    this.exam.gameTestConfig = [index];
  }

  @Emit()
  nextStep() {
    return;
  }
  @Emit()
  change() {
    return;
  }
}
